import {
  getEditionById,
  GetEditionByIdRequestParams,
} from "@/requests/editions/edition-by-id.request";
import { useQuery } from "@tanstack/react-query";

export const buildEditionByIdQueryKey = (
  variables: GetEditionByIdRequestParams,
) => ["companies", variables.companyId, "editions", variables.editionId];

export const useEditionById = (variables: GetEditionByIdRequestParams) => {
  return useQuery({
    queryKey: buildEditionByIdQueryKey(variables),
    queryFn: () => getEditionById(variables),
    enabled: Object.values(variables).every(Boolean),
    staleTime: 1000 * 60 * 60,
    retry: false,
  });
};
